// FeaturedContainer.js

import FeaturedCard from "@/components/FeaturedCard";
import { Box, Typography } from "@mui/material";
import { useFeatured } from "@/services/hooks";

export default function FeaturedContainer({ artistKey }) {
  const { data: artistContent } = useFeatured(artistKey);

  if (artistContent?.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        pt: 4,
        pb: 6,
        px: 2,
      }}
      // style={{ marginTop: "-10px" }}
    >
      <Typography variant="h6" sx={{ mb: 4, fontWeight: 800 }}>
        Featured
      </Typography>

      {/* Container for horizontal scroll */}
      <Box
        sx={{
          display: "flex",
          overflowX: "scroll",
          scrollbarWidth: "none" /* Firefox */,
          "&::-webkit-scrollbar": {
            /* WebKit */ display: "none",
          },
        }}
      >
        {artistContent?.map((content, index) => (
          <Box key={index} sx={{ mr: 4, minWidth: "300px" }}>
            <FeaturedCard content={content} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
